import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { ChakraProvider, theme } from "@chakra-ui/react";
import CoachingRouter from "./Coaching/Routers/CoachingRouter";
import ParentLandingPage from "./Parent/ParentLandingPage";
import LandingPageTech from "./Technology/LandingPageTech";
import TermsAndConditionsParent from "./Parent/TermsAndConditionsParent";
import TermsAndConditionsTech from "./Technology/TermsAndConditionsTech";
import TitleAndFaviconManager from "./TitleAndFaviconManager";
import StudentExamLobby from "./Platform/Student/StudentExamLobby";
import AboutTechPage from "./Technology/AboutTechPage";
import PlatformRouter from "./Platform/Routers/PlatformRouter";
import TechnologyRouter from "./Technology/Routers/TechnologyRouter";
import B2CRouter from "./B2C-TestSeries/Routers/B2CRouter";

import StudentAttemptInstructionStart from "./B2C-TestSeries/Practice Assessment Engine/StudentPages/StudentAttemptInstructionStart";
import StudentPracticeAttemptLobby from "./B2C-TestSeries/Practice Assessment Engine/StudentPages/StudentPracticeAttemptLobby";

const App: React.FC = () => {
  return (
    <ChakraProvider theme={theme}>
      <TitleAndFaviconManager />
      <Routes>
        <Route path="/" element={<Navigate to="/practice" replace />} />
        <Route path="/termsandconditions" element={<TermsAndConditionsParent />} />

        <Route path="/coaching/*" element={<CoachingRouter/>} />
        <Route path="/technologies/*" element={<TechnologyRouter/>} />
        <Route path="/platform/*" element={<PlatformRouter />} />
        <Route path="/practice/*" element={<B2CRouter />} />
        <Route path="/exam-window/:exam_attempt_id" element={<StudentExamLobby />} />
        <Route path="/mock-exam-window/:practice_attempt_id" element={<StudentPracticeAttemptLobby />} />
      </Routes>
    </ChakraProvider>
  );
};

export default App;